import {ReactNode} from "react";
import {useTranslation} from "react-i18next";
import {RenderableDocument, DibJsonNode} from "../../types";
import {extractText} from "../../contentUtils";
import {usePanel} from "../../panel/PanelContext";
import MessageCircle from "../../../../assets/message-circle.svg?react";
import contentLinkClasses from "../contentLink.module.css";
import classes from "./panelLink.module.css";

type PanelLinkVariant = "definition" | "footnote" | "footnote-edu";

export const PanelLink = ({
    node,
    map,
    children,
    variant,
}: {
    node: DibJsonNode;
    map: RenderableDocument;
    children: ReactNode[];
    variant: PanelLinkVariant;
}) => {
    const {openPanel} = usePanel();
    const {t} = useTranslation();

    const attrs = node.element?.attributes;
    const id = attrs?.["data-id"] ?? "";
    const segmentId =
        attrs?.["data-segment"] ?? attrs?.class ?? "";
    const resourceId = map.topicId;
    const text = extractText(map.elements, id);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        openPanel({
            label: text || variant,
            fetchType: "documentParts",
            params: {resourceId, segmentId, id},
        });
    };

    if (variant === "footnote-edu") {
        return (
            <button
                className={classes.iconButton}
                onClick={handleClick}
                type="button"
                data-pw="content-reference"
                aria-label={text || t("Word.Footnote", {defaultValue: "Footnote"})}
            >
                <MessageCircle width={16} height={16} />
            </button>
        );
    }

    if (variant === "footnote") {
        return (
            <sup>
                <a
                    href="#"
                    data-pw="content-reference"
                    className={`${contentLinkClasses.panelLink} ${classes.footnoteLink}`}
                    onClick={handleClick}
                >
                    {children}
                </a>
            </sup>
        );
    }

    // definition
    return (
        <a href="#" data-pw="content-reference" className={`${contentLinkClasses.panelLink} ${classes.definitionLink}`} onClick={handleClick}>
            {children}
        </a>
    );
};
